import type { ColumnFiltersState } from "@tanstack/react-table";
import { resolveServerId } from "../modules/merchandising/utils/metrics";

type ApiFilterOp = "gt" | "gte" | "lt" | "lte" | "eq" | "ne" | "in" | "contains";

const FILTER_OP_MAP: Record<string, ApiFilterOp> = {
  ">": "gt",
  ">=": "gte",
  "<": "lt",
  "<=": "lte",
  "=": "eq",
  "!=": "ne",
  eq: "eq",
  neq: "ne",
  gt: "gt",
  gte: "gte",
  lt: "lt",
  lte: "lte",
  anyof: "in",
  in: "in",
  contains: "contains",
};

type FilterValue = string | number | boolean | (string | number)[];

type DatasetsFilter = { id: string; value: { op: ApiFilterOp; value: FilterValue } };

function isAllValue(value: unknown): boolean {
  if (value === "all") return true;
  if (Array.isArray(value) && value.length === 1 && value[0] === "all") return true;
  if (Array.isArray(value) && value.length === 0) return true;
  return false;
}

export function adaptDatasetsFilters(columnFilters: ColumnFiltersState | undefined): DatasetsFilter[] {
  const result: DatasetsFilter[] = [];

  for (const filter of columnFilters ?? []) {
    const filterValue = filter.value as { op?: string; value?: FilterValue } | null;
    const op = filterValue?.op;
    const value = filterValue?.value;
    if (!op || value == null || value === "" || isAllValue(value)) continue;

    const fieldId = resolveServerId(filter.id);

    if (op === "-" && Array.isArray(value) && value.length === 2) {
      const [rangeStart, rangeEnd] = value as [string | number, string | number];
      result.push(
        { id: fieldId, value: { op: "gte", value: rangeStart } },
        { id: fieldId, value: { op: "lte", value: rangeEnd } },
      );
      continue;
    }

    const apiOp = FILTER_OP_MAP[op];
    if (!apiOp) continue;

    result.push({ id: fieldId, value: { op: apiOp, value } });
  }

  return result;
}
